// extracted by mini-css-extract-plugin
export default {"base":"vp_dWcId","info":"vp_iwEE2","icon":"vp_sPuOK","success":"vp_mt9LC","warning":"vp_NpU1g","error":"vp_hcRED","note":"vp_VDQ8S","text":"vp_TkFa8","title":"vp_AcwAT"};